import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseUnpaidConsolidatedPaymentReminderTemplates = [
  {
    id: '-129001',
    language: Language.EN,
    subject: 'Outstanding amounts',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: Outstanding amount related to the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Please find attached a statement of all outstanding amounts to date.</p>
        <p></p>
        <p>We kindly request that you proceed with the payment of the balance as soon as possible:</p>
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Amount: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Please find the statement attached.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-129002',
    language: Language.FR,
    subject: 'Créances ouvertes',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: montant impayé relatif au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Veuillez trouver ci-joint un décompte de tous les montants impayés à ce jour. </p>
        <p></p>
        <p>Nous vous prions de bien vouloir procéder au paiement du solde le plus rapidement possible:</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Montant: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Veuillez trouver le décompte en pièce jointe.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-129003',
    language: Language.NL,
    subject: 'Openstaand bedrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: openstaand bedrag met betrekking tot het huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Bijgevoegd vindt u een overzicht van alle openstaande bedragen tot op heden.</p>
        <p></p>
        <p>Wij verzoeken u vriendelijk zo spoedig mogelijk tot betaling van dit laatste over te gaan:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>U vindt het overzicht in de bijlage</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
    `,
  },
  {
    id: '-129004',
    language: Language.DE,
    subject: 'Ausstehende Beträge',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Sehr geehrte/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Ausstehender Betrag im Zusammenhang mit dem Mietvertrag für die Immobilie in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Im Anhang finden Sie eine Übersicht aller ausstehenden Beträge bis zum heutigen Datum.</p>
        <p></p>
        <p>Wir bitten Sie freundlich, den Saldo baldmöglichst zu begleichen:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Betrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Die Übersicht finden Sie im Anhang.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
